<style scoped>
modal-xl{
color: red;
max-width: 3000px !important;
}
</style>
<template>       
    <div class=" ">    
        <div class="clearfix row py-2 mb-2 no-margin">
            
            <div class="col-md-6 p-0">
                <div class="col-sm-5 pl-0">
                    <b-form-select v-model="year" :options="years" @change="reloadData()" class="m-1"></b-form-select>
                    <b-form-select v-model="month" :options="months" @change="reloadData()" class="m-1"></b-form-select>
                </div>
            </div>
            <div class="col-md-6 p-0">
                <div class="row d-flex justify-content-end no-margin">
                    <b-button variant="primary" class="d-flex justify-content-end m-1" @click="previewOrDownload(0)">Preview Report</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Excel</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset</b-button>
                </div>
            </div>
            
            
        </div>

        <div class="row justify-content-center no-margin">
           
            <div class="col-sm-12  px-0" v-if="this.is_preview">
                <table class="table attendance-table table-sticky"> 
                    <thead class="" style="">
                        <tr>                            
                            <td class="">Employee</td>
                            <td class="" align="center" v-for="(day_details , n) in week_days_header" :key="n" v-bind:style="{ backgroundColor: head_color[day_details.day] }">
                                <div :title="day_details.title" v-b-tooltip>{{n}}</div>                             
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(attendance , temp) in paginatedData" :key="attendance.id">
                            <td>{{ attendance.name }}</td>
                            <td v-for="(day_details , d) in week_days_header" :key="d" align="center">
                                <template v-if="month == this_month">
                                    <template v-if="(parseInt(d) <= parseInt(today_index))">
                                    
                                        <div v-if="day_details.day == 'weekend' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-info"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                        <div v-else-if="day_details.day == 'holiday' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-success"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                        <div v-else class="">
                                            
                                            <template v-if="attendance.attendances_list_by_day[d]">
                                                <div :id="'c'+attendance.attendances_list_by_day[d].id">
                                                    
                                                    <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1">
                                                        <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.auto_checkout }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                                
                                                            <br /> System Intervened                                                       
                                                        </b-tooltip>
                                                    </template>
                                                    
                                                    <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                        <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                                
                                                            <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template>                                                         -->
                                                        </b-tooltip>

                                                    </template>

                                                    <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in > 0) || (attendance.attendances_list_by_day[d].early_checkout > 0))">
                                                        <div v-if="attendance.attendances_list_by_day[d].leave_data">
                                                            
                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">
                                                                <b-icon rotate="180" icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                            </template>
                                                            <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">
                                                                <b-icon icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                            </template>
                                                            
                                                        </div>
                                                        <div v-else class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                            <b-icon icon="check" font-scale="2" :style="{ color: legend.late_early }"></b-icon>
                                                        </div>
                                                        
                                                        
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                            {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                        
                                                            
                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                                <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">On First Half Leave</template>
                                                                <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">On Second Half Leave</template>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="attendance.attendances_list_by_day[d].late_check_in > grace_time_late_check_in"> <br /> Late Clock In</template>
                                                                <template v-if="attendance.attendances_list_by_day[d].early_checkout > grace_time_early_checkout"> <br /> Early Clock Out</template>
                                                            </template>
                                                            
                                                            <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template> -->
                                                        </b-tooltip>
                                                    </template>
                                                    
                                                    <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                        <!-- On Leave -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                            On Leave                                      
                                                        </b-tooltip>
                                                    </template>
                                                    <template v-else-if="attendance.attendances_list_by_day[d].compen_leave_data">
                                                        <!-- On Compensatory Leave -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                            On Compensatory Leave [{{ attendance.attendances_list_by_day[d].compen_leave_data }}]                                      
                                                        </b-tooltip>
                                                    </template> 
                                                    <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                        <!-- absent -->
                                                        <div class="cursor-pointer">
                                                            <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                        </div>
                                                        <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">                                                
                                                            {{attendance.attendances_list_by_day[d].comment}}                                
                                                        </b-tooltip>
                                                    </template>
                                                    <template v-else-if="attendance.attendances_list_by_day[d].check_in == '00:00:00' && attendance.attendances_list_by_day[d].checkout == '00:00:00' && attendance.attendances_list_by_day[d].absent != 1">
                                                        
                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>
                                                        
                                                    </template>
                                                    <template v-else>
                                                        
                                                        <!-- Employee absent but didnot apply for a leave -->
                                                        <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                                        
                                                    </template>
                                                </div>                                       
                                                
                                            </template>
                                            <template v-else>
                                                <!-- Employee absent but didnot apply for a leave -->
                                                <!--<div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>-->
                                                <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                            </template>                                        
                                        </div>

                                    </template>
                                    <template v-else>
                                        <b-icon icon="dash" variant="info" font-scale="2"></b-icon>
                                    </template>
                                </template>

                                <template v-else>
                                    <div v-if="day_details.day == 'weekend' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-info"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                    <div v-else-if="day_details.day == 'holiday' && attendance.attendances_list_by_day[d].check_in == '0'" class="text-success"><b-icon icon="dash" variant="info" font-scale="2"></b-icon></div>
                                    <div v-else class="">
                                        
                                        <template v-if="attendance.attendances_list_by_day[d]">
                                            <div :id="'c'+attendance.attendances_list_by_day[d].id">
                                                
                                                <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1">
                                                    <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                        <b-icon icon="check" font-scale="2" :style="{ color: legend.auto_checkout }"></b-icon>
                                                    </div>
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                        {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                                
                                                        System Intervened
                                                    </b-tooltip>
                                                </template>
                                                
                                                <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in <= grace_time_late_check_in) && (attendance.attendances_list_by_day[d].early_checkout <= grace_time_early_checkout) && (attendance.attendances_list_by_day[d].absent == 0) && (attendance.attendances_list_by_day[d].activity_log != ''))">
                                                    <div class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                        <b-icon icon="check" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                    </div>
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                        {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                                
                                                        <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template> -->
                                                    </b-tooltip>

                                                </template>

                                                <template v-else-if="((attendance.attendances_list_by_day[d].late_check_in > 0) || (attendance.attendances_list_by_day[d].early_checkout > 0))">
                                                    <div v-if="attendance.attendances_list_by_day[d].leave_data">
                                                            
                                                        <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">
                                                            <b-icon rotate="180" icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                        </template>
                                                        <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">
                                                            <b-icon icon="circle-half" font-scale="2" :style="{ color: legend.ontime }"></b-icon>
                                                        </template>
                                                        
                                                    </div>
                                                    <div v-else class="cursor-pointer" @click="showActivity(attendance.attendances_list_by_day[d])">
                                                        <b-icon icon="check" font-scale="2" :style="{ color: legend.late_early }"></b-icon>
                                                    </div>
                                                    
                                                    
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                        {{formateMe(attendance.attendances_list_by_day[d].check_in) + ' to ' + formateMe(attendance.attendances_list_by_day[d].checkout) + ' ' + attendance.attendances_list_by_day[d].comment}}                                        
                                                        
                                                        <template v-if="attendance.attendances_list_by_day[d].leave_data">
                                                            <template v-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 1">On First Half Leave</template>
                                                            <template v-else-if="attendance.attendances_list_by_day[d].leave_data.leave_day == 2">On Second Half Leave</template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="attendance.attendances_list_by_day[d].late_check_in > grace_time_late_check_in"> <br /> Late Clock In</template>
                                                            <template v-if="attendance.attendances_list_by_day[d].early_checkout > grace_time_early_checkout"> <br /> Early Clock Out</template>
                                                        </template>
                                                        
                                                        <!-- <template v-if="attendance.attendances_list_by_day[d].auto_checkout == 1"> <br /> System Intervened</template> -->
                                                    </b-tooltip>
                                                </template>
                                                
                                                <template v-else-if="attendance.attendances_list_by_day[d].leave_data">
                                                    <!-- On Leave -->
                                                    <div class="cursor-pointer">
                                                        <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                    </div>
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                        On Leave                                      
                                                    </b-tooltip>
                                                </template>
                                                <template v-else-if="attendance.attendances_list_by_day[d].compen_leave_data">
                                                    <!-- On Compensatory Leave -->
                                                    <div class="cursor-pointer">
                                                        <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                    </div>
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover">                                                
                                                        On Compensatory Leave [{{ attendance.attendances_list_by_day[d].compen_leave_data }}]                                      
                                                    </b-tooltip>
                                                </template> 
                                                <template v-else-if="attendance.attendances_list_by_day[d].absent == 1">
                                                    <!-- absent -->
                                                    <div class="cursor-pointer">
                                                        <b-icon icon="x" font-scale="2" :style="{ color: legend.absent }"></b-icon>
                                                    </div>
                                                    <b-tooltip :target="'c'+attendance.attendances_list_by_day[d].id" triggers="hover" v-if="attendance.attendances_list_by_day[d].comment != ''">                                                
                                                        {{attendance.attendances_list_by_day[d].comment}}                                
                                                    </b-tooltip>
                                                </template>
                                                <template v-else-if="attendance.attendances_list_by_day[d].check_in == '00:00:00' && attendance.attendances_list_by_day[d].checkout == '00:00:00' && attendance.attendances_list_by_day[d].absent != 1">
                                                    
                                                    <!-- Employee absent but didnot apply for a leave -->
                                                    <div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>
                                                    
                                                </template>
                                                <template v-else>
                                                    
                                                    <!-- Employee absent but didnot apply for a leave -->
                                                    <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                                    
                                                </template>
                                            </div>                                       
                                            
                                        </template>
                                        <template v-else>
                                            <!-- Employee absent but didnot apply for a leave -->
                                            <!--<div class="cursor-pointer" @click="showResolve(attendance.employee_id , day_details.date)"><span class="cross-wrapper"><b-icon icon="x" variant="danger" font-scale="1.5"></b-icon></span></div>-->
                                            <b-icon icon="blank" variant="" font-scale="1.5"></b-icon>
                                        </template>                                        
                                    </div>
                                </template>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                <div v-else class="px-3">
                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                        </div>
                    
                    </div>    
                </div>                
            </div>
        </div>



    <div class="container p-0" v-if="this.is_grid_diplayable">
        
        <template v-if="custom_list.length > 0">
            <div class="font-weight-bold">Select employee(s) below to get the report.</div>
            <common-list-leave-report :checkbox="checkbox" :leave_type_options="this.leave_type_options"   :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report>
        
        </template>
        <template v-else>
            <div class="font-weight-bold">No data found on that range.</div>
        </template>
    
    </div>
        
    </div>
</template>
<script>
    import moment from 'moment'
    export default{
        
        mounted() {
            if(this.check_ce == 1)
            {                
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;

                
            }   
        },
        props: [ 'moment'],
        components: { },
        data(){            
            const now = new Date(); 
            return {                
                // for common grid
                selected: [],
                checkbox:1,
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','phone','email','jobposition','department','branch'], /* Default Column List */
                appended_column:[                 
                    /* { value: "text_type_1", text: "Text 1",type: "text"}, */
                ],   
                leave_type_options:[],                /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                /***Child Component property data */

                tmp_custom_list:[],
                // for common grid
                attendances:[],              
                week_days_header:[],
                head_color : {weekend : '#aaaaaa' , holiday : '#aaaaaa'},
                search:'',
                length: 50,
                temp_length: 50,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                ce : true,
                today_index : 0,
                grace_time_late_check_in : 0,
                grace_time_early_checkout : 0,

                blankmsg : '',


                attendances_date : null,

                check_in : null, 
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,

                edit_date : null,
                employee_id : 0,

                resolve_flg : 0,

                this_month: now.getMonth() + 1,
                month: now.getMonth() + 1,
                year: now.getFullYear(),

                months: [
                    { text: 'January', value: '1' },
                    { text: 'February', value: '2' },
                    { text: 'March', value: '3' },
                    { text: 'April', value: '4' },
                    { text: 'May', value: '5' },
                    { text: 'June', value: '6' },
                    { text: 'July', value: '7' },
                    { text: 'August', value: '8' },
                    { text: 'September', value: '9' },
                    { text: 'October', value: '10' },
                    { text: 'November', value: '11' },
                    { text: 'December', value: '12' }
                ],
                years: [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],

                // new NHL 
                preview_data: '',
                is_preview: 0,
                is_grid_diplayable: 1,
                employee_ids: [],

                legend : {'absent':'#DE0000' , 'late_early': '#BF8F00' , 'ontime': '#18A022' , 'auto_checkout':'#DE0000'}
            }
        },
        methods:{
            listReturn:function(data)
            {
                this.selected = data;
                this.employee_ids = this.selected.selected;

            },
            getCustomList: function()
            { 
               
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/leaveattendancereport/getcustomlist?flg=1&month='+this.month+'&year='+this.year , {

                }).then(function(response){

                    /* Assingning the list */ 
                    this.tmp_custom_list = response.data.employee_data;
                    this.leave_type_options = response.data.leave_type_options;
                    /* Assingning the Options */ 
                    this.company_options = response.data.options;

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    if(this.tmp_custom_list.length > 0 )
                    {
                        this.tmp_custom_list.forEach(element => {

                                if(element.leave_type.length>0)
                                {
                                    let types = [];
                                    let type_ids = [];
                                    element.leave_type.forEach(newelement => {

                                        types.push(newelement.value);
                                        type_ids.push(newelement.id);
                                        
                                        });

                                        element.leave_types = types.join(" , ");
                                        element.leave_type_ids = type_ids;
                                }
                                else
                                {
                                    element.leave_types = 'Not Available';
                                    element.leave_type_ids = [];

                                }
                             });
                        
                    }
                    
                    this.custom_list = this.tmp_custom_list;
                    

                    this.list_key = this.list_key + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            }, 
            reloadData: function()
            {                
                this.resolve_flg = 0;
                this.is_preview = 0;
                this.resetView();
                this.getCustomList();
                // this.getEmployeesAttendance();
            },
            // previewReport: function()
            // {                
            //     // this.resolve_flg = 0;
            //     this.getEmployeesAttendance();
            // },
            resetView: function()
            { 
                this.preview_data = '';
                this.selected = [];
                this.list_key +=1;
                this.is_preview = 0;
                this.is_grid_diplayable = 1;

            },
            convertMinsToHrsMins: function (minutes) {
                var h = Math.floor(minutes / 60);
                var m = minutes % 60;
                h = h < 10 ? '0' + h : h;
                m = m < 10 ? '0' + m : m;
                return h + ':' + m;
            },
            formateMe :function(minutes){
                return moment(minutes, "hh:mm").format('LT');
            },
            previewOrDownload :function(preview_or_download_flg)
            {
                
                if (typeof this.selected.selected == 'undefined')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (typeof this.year == 'undefined')
                    this.$bvToast.toast("No year selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (typeof this.month == 'undefined')
                    this.$bvToast.toast("No month selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {   
                    this.getEmployeesAttendance(preview_or_download_flg);
                }
            },
            resolve : function()
            {

            },

            getEmployeesAttendance: function(preview_or_download_flg)
            {                
                          
                if(!this.checkNet()) return false;

                if (typeof this.selected.selected == 'undefined')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (this.selected.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (this.month == '')
                    this.$bvToast.toast("No month selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                

                else
                {
                    this.$bvToast.toast("It might take a while", {title: 'Info',variant: 'info',solid: true});

                    let currentObj = this;
                    // axios.get(this.$api_url+'/employee/attendance/month' , {
                    axios.post(this.$api_url+'/employee/attendance/month/daywise/report' , {
                        // params: {
                            month: this.month,
                            year: this.year,
                            employee_ids: this.employee_ids,
                            export_flg :preview_or_download_flg,
                            report_flg :1,
                        // }
                    }).then(function(response){
                        if(preview_or_download_flg  == 0){
                            this.attendances = response.data.attendances_list;
                            

                            if(this.attendances.length == 0)
                                this.blankmsg = "Looks like you have not added any employee attendance yet.";

                            this.is_grid_diplayable = 0;
                            this.is_preview = 1;
                            this.week_days_header = response.data.week_days_header;

                            this.head_color = response.data.head_color;

                            this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                            { value: 50, text: "50" },
                                                            { value: 100, text: "100" },
                                                            { value: 200, text: "200" },
                                                            { value: 500, text: "500" }, 
                                                            { value: this.attendances.length, text: "All" }
                                                        ]; 
                            
                            this.$bvToast.toast("Completed", {title: 'Success',variant: 'success',solid: true});
                            this.people = this.attendances.length;

                            this.today_index = response.data.today_index;

                            this.grace_time_late_check_in = response.data.grace_time_late_check_in;
                            this.grace_time_early_checkout = response.data.grace_time_early_checkout;

                            this.is_preview = 1;
                        }                             
                        else
                        {
                            this.$bvToast.toast("Completed", {title: 'Success',variant: 'success',solid: true});
                            // this.is_preview = 0;
                            //console.log('from dowload as an excel');
                            //window.open(response.data);
                            //console.log(response);
                            var fileURL = response.data;
                            
                            this.downloadFileContent(fileURL);
                            //console.log(fileURL);
                        } 
                        
                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                }


                
            },
            setFirstPage :  function()
            {  
                this.pagination.currentPage = 1;                
                this.length = this.temp_length;   
            },

             download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            }, 
            

        },
        created: function(){
            
            // this.getEmployeesAttendance();
            this.getCustomList();
            
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.attendances;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            
        }
    }
</script>
<style scoped>

</style>
